import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  
  constructor(private readonly toastr: ToastrService) {}

  validateCompanyAndYear(companyId: number | null, yearId: number | null): boolean {
    if (!companyId) {
      this.toastr.error('Please select a company.');
      return false;
    }

    if (!yearId) {
      this.toastr.error('Please select a claim year.');
      return false;
    }

    return true;
  }
    atLeastOneValidator(controlNames: string[]): ValidatorFn {
    return (formGroup: AbstractControl) => {
      const controls = controlNames.map(name => formGroup.get(name));
      const isValid = controls.some(control => control?.value?.toString() && control?.value?.toString().trim() !== '');
      return isValid ? null : { atLeastOneRequired: true };
    };
  }
}
